<template>
  <div class="hangar-root">
    <div v-if="!user.id" class="notification is-light">
      Загрузка…
    </div>

    <template v-else>
      <p class="title is-4">Ангар</p>

      <div v-if="!atStation" class="notification is-warning is-light">
        Ангар доступен только на станции
      </div>

      <div v-else-if="loading" class="notification is-light">
        Загрузка кораблей…
      </div>

      <div v-else-if="spaceships.length === 0" class="notification is-light">
        В ангаре нет кораблей
      </div>

      <template v-else>
        <SpaceshipPreview
          v-for="spaceship in spaceships"
          :key="spaceship.id"
          :spaceship="spaceship"
        />
      </template>
    </template>
  </div>
</template>

<script>
import SpaceshipService from '../services/SpaceshipService'
import SpaceshipPreview from '../components/SpaceshipPreview'

export default {
  components: {
    SpaceshipPreview,
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      spaceships: [],
      atStation: true,
      loading: false,
    }
  },
  watch: {
    'user.id': {
      immediate: true,
      handler (id) {
        if (id) this.loadHangar()
      },
    },
  },
  methods: {
    async loadHangar () {
      this.loading = true
      try {
        const resp = await SpaceshipService.getHangar()
        this.spaceships = resp.data || []
        this.atStation = resp.meta ? resp.meta.at_station !== false : true
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.hangar-root {
  max-width: 640px;
  margin: 0 auto;
}
</style>
